import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Sticky from 'react-stickynode'
import { me, showVideos } from '../initial_state'
import {
  BREAKPOINT_EXTRA_SMALL, BREAKPOINT_MEDIUM, BREAKPOINT_SMALL, CX, MODAL_PRO_UPGRADE,
} from '../constants'
import Layout from './layout'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  GroupsPanel,
  SignUpLogInPanel,
  UserSuggestionsPanel,
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
} from '../features/ui/util/async_components'
import { connect } from 'react-redux'
import { openModal } from '../actions/modal'

class ProTimelineLayout extends ImmutablePureComponent {

  handleOnOpenProModal = () => {
    const subtitle = 'pro-timeline'
    this.props.dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle }))
  }

  render() {
    const { children, width, noRightSidebar, isPro } = this.props

    const layout = [
      SignUpLogInPanel,
      <WrappedBundle key='pro-timeline-layout-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'pro-timeline.sidebar', position: 1 }} />,
      <WrappedBundle key='pro-timeline-layout-link-footer' component={LinkFooter} />,
      <WrappedBundle key='home-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'pro-timeline.sidebar', position: 1 }} />,
    ].filter(Boolean)

    const tabs = [
      {
        title: 'Explore',
        to: !!me ? '/explore' : '/',
      },
      {
        title: 'PRO Feed',
        to: '/timeline/pro',
      },
      {
        title: 'Gab TV',
        to: '/timeline/videos',
      },
      {
        title: 'Clips',
        to: '/timeline/clips',
      },
      {
        title: 'Photos',
        to: '/timeline/photos',
      },
      {
        title: 'Polls',
        to: '/timeline/polls',
      },
    ]
  
    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const isSmall = !isXS && width <= BREAKPOINT_SMALL
    const isMD = !isSmall && !isXS && width <= BREAKPOINT_MEDIUM
    const isLarge = width >= BREAKPOINT_MEDIUM

    const leftLayout = [
      <WrappedBundle key='pro-timeline-layout-groups-panel' component={GroupsPanel} componentParams={{ groupType: 'featured', noPanel: 1, max: 6, padded: 1 }} />,
      <WrappedBundle key='pro-timeline-layout-user-suggestions-panel' component={UserSuggestionsPanel} componentParams={{ suggestionType: 'verified', noPanel: 1, padded: 1 }} />,
    ]
    const sidebarLayout = <SidebarPanelGroup layout={leftLayout} />
    
    const mainBlockClasses = CX({
      d: 1,
      w100PC: 1,
      px15: !isMD,
    })

    const sidebarClasses = CX({
      d: 1,
      w340PX: 1,
      // pr15: isLarge,
      pl10: isLarge,
      pr10: !isLarge,
    })

    const titleClasses = CX({
      d: 1,
      flexRow: 1,
      jcCenter: 1,
      aiCenter: 1, 
      mb10: !isXS,
    })

    const title = (
      <span className={titleClasses}>
        <span className={[_s.bgPro, _s.cBlack, _s.radiusSmall, _s.px5, _s.py5].join(' ')}>PRO</span>
        <span className={[_s.d, _s.ml5].join(' ')}>
          Timelines
        </span>
      </span>
    )

    const actions = !isPro ? [
      {
        onClick: () => this.handleOnOpenProModal(),
        icon: 'pro',
      }
    ] : undefined

    return (
      <Layout
        showGlobalFooter
        noRightSidebar
        showLinkFooterInSidebar
        noComposeButton
        page='pro-timeline'
        actions={actions}
        title={title}
        tabs={isXS ? undefined : tabs}
        sidebarChildren={sidebarLayout}
      >
        {
          isXS &&
          <div className={[_s.d, _s.w100PC].join(' ')}>
            <div className={[_s.d, _s.w100PC, _s.z1].join(' ')}>
              {
                !me &&
                <div className={[_s.d, _s.mt15, _s.px10].join(' ')}>
                  <WrappedBundle component={SignUpLogInPanel} componentParams={{ isXS: true }} />
                </div>
              }
              {children}
            </div>
          </div>
        }

        {
          !isXS &&
          <div className={mainBlockClasses}>
            <div className={[_s.d, _s.flexRow, _s.w100PC, _s.jcEnd].join(' ')}>
              
              { noRightSidebar && children }
              {
                !noRightSidebar &&
                <div className={[_s.d, _s.mlAuto, _s.mrAuto, _s.w645PX, _s.z1].join(' ')}>
                  {children}
                </div>
              }
              {
                !noRightSidebar && !isSmall && !isXS &&
                <div className={[_s.d, _s.w340PX].join(' ')}>
                  <Sticky top={73} enabled>
                    <div className={sidebarClasses}>
                      <SidebarPanelGroup page='pro-timeline' layout={layout} />
                    </div>
                  </Sticky>
                </div>
              }
            </div>
          </div>
        }
      </Layout>
    )
  }

}

const mapStateToProps = (state) => ({
  width: state.getIn(['settings', 'window_dimensions', 'width']),
  isPro: !!me ? state.getIn(['accounts', me, 'is_pro']) : false,
})

ProTimelineLayout.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.node,
  group: ImmutablePropTypes.map,
  groupId: PropTypes.string,
  layout: PropTypes.object,
  relationships: ImmutablePropTypes.map,
  title: PropTypes.string,
  noRightSidebar: PropTypes.bool,
}

export default connect(mapStateToProps)(ProTimelineLayout)
